import React, { useEffect } from 'react';
import { Home } from './pages/Home';
export function App() {
  useEffect(() => {
    document.title = 'Anthropify';
  }, []);
  return <Home data-id="element-0" />;
}